import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display", "input"]
  static values = { url: String }

  connect() {
    // Klick auf Display startet Edit-Modus
    this.displayTarget.addEventListener('click', () => this.startEdit())
  }

  startEdit() {
    this.displayTarget.classList.add('hidden')
    this.inputTarget.classList.remove('hidden')
    this.inputTarget.focus()
  }

  save() {
    const newValue = this.inputTarget.value
    const oldValue = this.getCurrentWeight()
    
    // Hole die URL direkt aus dem data-Attribut
    const url = this.inputTarget.getAttribute('data-weight-select-url-value')
    
    // Saving weight
    
    if (newValue === oldValue) {
      this.cancelEdit()
      return
    }

    if (!url) {
      this.showFlash('Fehler: URL nicht gefunden', 'error')
      this.cancelEdit()
      return
    }

    // Hole den Text aus der ausgewählten Option
    const selectedOption = this.inputTarget.options[this.inputTarget.selectedIndex]
    const displayText = selectedOption ? selectedOption.text : newValue

    // Sofort den Edit-Modus beenden und neuen Wert anzeigen
    this.displayTarget.textContent = displayText
    this.cancelEdit()

    // Sende Turbo Stream Request mit korrekten Parametern
    const formData = new FormData()
    formData.append('competency_requirement[weight]', newValue)
    formData.append('_method', 'PATCH')

    fetch(url, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
        'Accept': 'text/vnd.turbo-stream.html',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    })
    .then(response => {
      // Response received
      if (response.ok) {
        // Turbo Frame wird automatisch aktualisiert
        this.showFlash('Gewichtung erfolgreich aktualisiert', 'success')
      } else {
        // Response not ok
        this.showFlash('Fehler beim Aktualisieren', 'error')
        // Bei Fehler den alten Wert wiederherstellen
        this.displayTarget.textContent = oldValue
      }
    })
    .catch(error => {
      // Error occurred
      this.showFlash('Fehler beim Aktualisieren', 'error')
      // Bei Fehler den alten Wert wiederherstellen
      this.displayTarget.textContent = oldValue
    })
  }

  cancelEdit() {
    this.displayTarget.classList.remove('hidden')
    this.inputTarget.classList.add('hidden')
  }

  getCurrentWeight() {
    // Extrahiere die aktuelle Gewichtung aus der Anzeige
    return this.displayTarget.textContent.trim()
  }

  showFlash(message, type) {
    const flashContainer = document.getElementById('flash')
    if (flashContainer) {
      const alertClass = type === 'success' ? 'alert-success' : 'alert-danger'
      flashContainer.innerHTML = `<div class="alert ${alertClass}">${message}</div>`
      
      // Automatisch ausblenden nach 3 Sekunden
      setTimeout(() => {
        flashContainer.innerHTML = ''
      }, 3000)
    }
  }
} 